/* eslint-disable no-param-reassign */
export const getDefaultLocale = () => 'es-MX';

export const getDefaultLang = () => 'es';
